var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card card-primary" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("p", [
        _vm._v(
          "\n            Using email is the best way to communicate with parents/caregivers about Picture Day (and we use emails ONLY for this purpose). It reduces questions to administration and helps reduce paper waste. If you aren't providing emails, check the opt-out box.\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "custom-control custom-checkbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.opt_out,
              expression: "form.opt_out",
            },
          ],
          staticClass: "custom-control-input",
          class: { "is-invalid": _vm.errors["opt_out"] },
          attrs: { id: "rosters_parentEmailsOptOut", type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.form.opt_out)
              ? _vm._i(_vm.form.opt_out, null) > -1
              : _vm.form.opt_out,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.form.opt_out,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.form, "opt_out", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.form,
                      "opt_out",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.form, "opt_out", $$c)
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "custom-control-label",
            attrs: { for: "rosters_parentEmailsOptOut" },
          },
          [
            _vm._v(
              "\n                Don't include parent emails.\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.errors["opt_out"]
          ? _c("div", { staticClass: "invalid-feedback" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.errors["opt_out"]) +
                  "\n            "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("Parent Emails Opt-Out"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }